import React from "react";

import thumbIcon from "../Assets/Images/thumb.svg";
import helpIcon from "../Assets/Images/help.svg";
import globeIcon from "../Assets/Images/globe.svg";
import gearIcon from "../Assets/Images/gear.svg";
import cellphoneIcon from "../Assets/Images/cellphone.svg";

const AllIncluded = () => {
  return (
    <div className="all-included">
      <h3>Included in all plans</h3>
      <p><img style={{marginLeft: 3}} src={cellphoneIcon} /> Custom mobile app for iOs and Android</p>
      <p><img src={gearIcon} /> AWS setup</p>
      <p><img src={globeIcon} /> Web widget and On Demand Portal</p>
      <p><img src={thumbIcon} /> Unlimited .mp4 downloads from archive</p>
      <p><img src={helpIcon} /> Support</p>
    </div>
  );
};
export default AllIncluded;
